import "../sass/app.scss"

import ThreeSlideCarousel from "./modules/ThreeSlideCarousel"
import HomeCarousel from "./modules/HomeCarousel"
import CollapseMobileMenu from "./modules/CollapseMobileMenu"

const threeSlideCarousel = new ThreeSlideCarousel();
const homeCarousel = new HomeCarousel();
const collapseMobileMenu = new CollapseMobileMenu();